import { render, staticRenderFns } from "./ModalImportConfig.vue?vue&type=template&id=2c0b583d&scoped=true&"
import script from "./ModalImportConfig.vue?vue&type=script&lang=js&"
export * from "./ModalImportConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalImportConfig.vue?vue&type=style&index=0&id=2c0b583d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b583d",
  null
  
)

export default component.exports